module.exports = __webpack_public_path__ + "img/44.3601783c.png";